<template>
  <div class="modal" v-if="$root.user.opened">
    <div class="modal__container">
      <div class="modal__inner">
        <a href="#" class="modal__close" @click="close">
          <i class="fas fa-times"></i>
        </a>

        <div class="wrapper">
          <div class="row row--inline row--reset">
            <div class="col col--3 col--inline mq-mob-lrg--12"></div>
            <div
              class="col col--inline mq-mob-lrg--12  col--12"
            >
              <div class="col__inner">
                <div
                  class="auth auth--nosocial"
                  v-if="isLogin"
                >
                  <h2 class="auth__ttl popup">{{ __("Sign in") }}</h2>

                  <form
                    action=""
                    v-on:submit.prevent="submitSignIn"
                    method="post"
                    class="form"
                  >
                    <div class="form__field">
                      <input
                        type="text"
                        id="email"
                        v-model="login.email"
                        class="form__input form__input--secondary"
                        :placeholder="__('Username or email')"
                        required
                      />
                    </div>
                    <div class="form__field">
                      <input
                        type="password"
                        id="password"
                        class="form__input form__input--secondary"
                        :placeholder="__('Password')"
                        required
                        v-model="login.password"
                      />
                    </div>

                    <div
                      class="alert alert--sml alert--error alert--left"
                      v-if="errors.signIn.length > 0"
                      role="alert"
                    >
                      <span
                        v-for="error in errors.signIn"
                        v-html="__(error)"
                      ></span>
                    </div>

                    <div class="auth__btn">
                      <a href="#" class="auth__btn__link" @click="change">{{
                        __("Register now?")
                      }}</a>
                      <a href="/account/forgot" class="auth__btn__link">&nbsp;|&nbsp;{{
                        __("Forgotten password?")
                      }}</a>
                      <button
                        class="auth__btn__item btn btn--quaternary"
                        type="submit"
                      >
                        {{ __("Sign In") }}
                      </button>
                    </div>
                  </form>

                  <div class="loading loading--primary" v-if="loading">
                    <div class="loading__inner">
                      <div class="loading__spinner"></div>
                    </div>
                  </div>
                </div>

                <div class="auth" v-if="!isLogin">
                  <h2 class="auth__ttl popup">{{ __("Register with us") }}</h2>

                  <form
                    action=""
                    v-on:submit.prevent="submitRegister"
                    method="post"
                    class="form"
                  >
                    <div class="form__field">
                      <input
                        type="text"
                        id="registerName"
                        v-model="register.name"
                        class="form__input form__input--secondary"
                        :placeholder="__('Name')"
                        required
                      />
                    </div>
                    <div class="form__field">
                      <input
                        type="text"
                        id="registerEmail"
                        v-model="register.email"
                        class="form__input form__input--secondary"
                        :placeholder="__('Email Address')"
                        required
                      />
                    </div>
                    <div class="form__field">
                      <input
                        type="text"
                        id="registerEmailConfirmation"
                        v-model="register.email_confirmation"
                        class="form__input form__input--secondary"
                        :placeholder="__('Confirm Email Address')"
                        required
                      />
                    </div>
                    <div class="form__field">
                      <input
                        type="password"
                        id="registerPassword"
                        class="form__input form__input--secondary"
                        :placeholder="__('Password')"
                        required
                        v-model="register.password"
                      />
                    </div>
                    <div class="form__field">
                      <input
                        type="password"
                        id="registerConfirmPassword"
                        class="form__input form__input--secondary"
                        :placeholder="__('Confirm Password')"
                        required
                        v-model="register.confirm_password"
                      />
                    </div>

                    <div
                      class="alert alert--sml alert--error alert--left"
                      v-if="errors.register.length > 0"
                      role="alert"
                    >
                      <span
                        v-for="error in errors.register"
                        v-html="__(error)"
                      ></span>
                    </div>

                    <div class="auth__btn">
                      <a href="#" class="auth__btn__link" @click="change">{{
                        __("Already got an account?")
                      }}</a>
                      <button
                        class="auth__btn__item btn btn--quaternary"
                        type="submit"
                      >
                        {{ __("Register") }}
                      </button>
                    </div>
                  </form>

                  <div class="loading loading--primary" v-if="loading">
                    <div class="loading__inner">
                      <div class="loading__spinner"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    redirectUrl: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    loading: false,
    isLogin: true,

    errors: {
      signIn: [],
      register: [],
    },

    login: {
      email: "",
      password: "",
      redirect: false,
    },

    register: {
      name: "",
      email: "",
      email_confirmation: "",
      password: "",
      confirm_password: "",
    },
  }),
  methods: {
    close() {
      event.preventDefault();
      this.$root.user.opened = false;
      this.$root.user.redirect = false;
      this.login.redirect = false;
    },

    change() {
      event.preventDefault();

      this.isLogin = !this.isLogin;
    },

    submitSignIn() {
      if (this.loading) return;
      this.loading = true
      this.errors.signIn = [];

      this.login.redirect = this.$root.user.redirect;

      // Axios
      axios
        .post("/account/sign-in", this.login)
        .then((response) => {
          if (response.data.success) {
            if (this.login.redirect) {
              return window.location.replace(this.login.redirect);
            }
            if (this.redirectUrl.substr(0, 4) !== 'http') {
              this.redirectUrl = '/' + this.redirectUrl;
            }
            window.location.replace(this.redirectUrl);
          } else {
            this.errors.signIn.push(
              this.__("The email and/or password you provided is invalid.")
            );
            this.loading = false
          }

          this.loading = false;
        })
        .catch((error) => {
          if (typeof error.response.data.errors != "undefined") {
            for (let key in error.response.data.errors) {
              let err = error.response.data.errors[key];

              if (typeof err == "string") {
                this.errors.signIn.push(err);
              } else {
                for (let nKey in err) {
                  this.errors.signIn.push(err[nKey]);
                }
              }
            }
          }
          this.loading = false;
        });
    },
    submitRegister() {
      if (this.loading) return;
      this.loading = true
      this.errors.register = [];

      // Axios
      axios
        .post("/account/register", this.register)
        .then((response) => {
          if (response.data.success) {
            if (this.redirectUrl.substr(0, 4) !== 'http') {
              this.redirectUrl = '/' + this.redirectUrl;
            }
            window.location.replace(this.redirectUrl);
          } else {
            this.errors.register.push(
              this.__(
                "We were unable to register your account at this time. Please try again later."
              )
            );
            this.loading = false;
          }
        })
        .catch((error) => {
          if (typeof error.response.data.errors != "undefined") {
            for (let key in error.response.data.errors) {
              let err = error.response.data.errors[key];

              if (typeof err == "string") {
                this.errors.register.push(err);
              } else {
                for (let nKey in err) {
                  this.errors.register.push(err[nKey]);
                }
              }
            }
          }
          this.loading = false;
        });
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// resources/js/components/Auth.vue